// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__2O1KP","subtitle":"Title_subtitle__1xt-_"};